'use client';

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import { useLoadScript } from '@react-google-maps/api';
import React, { createContext, useContext } from 'react';
import { mapLibraries as libraries } from '@/utils/consts';
interface GoogleMapsContextType {
  isLoaded: boolean;
  loadError: Error | undefined;
}
const GoogleMapsContext = createContext<GoogleMapsContextType | undefined>(undefined);
interface GoogleMapsProviderProps {
  children: React.ReactNode;
}
export const GoogleMapsProvider: React.FC<GoogleMapsProviderProps> = t0 => {
  const $ = _c(7);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      id: "google-map-script",
      googleMapsApiKey: process.env.GOOGLE_MAPS_API_KEY as string,
      libraries
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    isLoaded,
    loadError
  } = useLoadScript(t1);
  let t2;
  if ($[1] !== isLoaded || $[2] !== loadError) {
    t2 = {
      isLoaded,
      loadError
    };
    $[1] = isLoaded;
    $[2] = loadError;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children || $[5] !== t2) {
    t3 = <GoogleMapsContext.Provider value={t2} data-sentry-element="GoogleMapsContext.Provider" data-sentry-component="GoogleMapsProvider" data-sentry-source-file="GoogleMapsProvider.tsx">{children}</GoogleMapsContext.Provider>;
    $[4] = children;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export const useGoogleMaps = () => {
  const context = useContext(GoogleMapsContext);
  if (context === undefined) {
    throw new Error("useGoogleMaps must be used within a GoogleMapsProvider");
  }
  return context;
};